import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ShiftService } from './shift.service';

const service = new ShiftService();

export interface ShiftState {}

const shiftStore: Module<ShiftState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getShifts(_, data: { companyId: number; query?: LocationQuery }) {
         return await service.getShifts(data.companyId, data.query);
      },

      async deleteShift(_, data: { companyId: number; shiftId: number }) {
         return await service.deleteShift(data.companyId, data.shiftId);
      },

      async changeShift(_, data: { companyId: number; shift: any }) {
         return await service.putShift(data.companyId, data.shift);
      },

      async createShift(_, data: { companyId: number; shift: any }) {
         return await service.postShift(data.companyId, data.shift);
      },
   },
};

export default shiftStore;
